import React from "react";
import ModalComponent from "@/components/modal";
import "@/styles/form/homePageOnboarding.scss";
import { Col, Row } from "antd";
import { useDispatch } from "react-redux";
import { setModalOpen } from "@/reducers/commonSlice";
import { STAGE_KEY } from "@/lib/constant";

const plans = [
  {
    label: "Planning to apply abroad",
    value: STAGE_KEY.PreApplication,
    image: "/assets/images/stage1.png",
  },
  {
    label: "Already Applied Abroad",
    value: STAGE_KEY.AlreadyApplied,
    image: "/assets/images/stage2.png",
  },
  {
    label: "Ready To Fly Abroad",
    value: STAGE_KEY.GotAdmission,
    image: "/assets/images/stage3.png",
  },
  {
    label: "Already at University Abroad",
    value: STAGE_KEY.AlreadyAtUniversity,
    image: "/assets/images/stage4.png",
  },
];

const HomePageOnboarding = ({ isOpen }) => {
  const dispatch = useDispatch();

  const handleSaveStage = (value) => {
    localStorage.setItem("stage", value);
    dispatch(setModalOpen(false));
  };
  return (
    <ModalComponent isOpen={isOpen} width={"75%"} closeIcon className="select-stage-wrapper">
      <div className="main-title">Welcome to Inforens, the Home of International Students</div>
      <div className="sub-title">Choose your stage below:</div>
      <Row
        gutter={[
          { xs: 10, sm: 10, md: 24 },
          { xs: 20, sm: 20, md: 24 },
        ]}
        className="stage-wrapper"
      >
        {plans.map((p, i) => {
          return (
            <Col xs={12} sm={12} md={12} lg={6} xl={6} className="plan-card" key={i}>
              <div className="content" onClick={() => handleSaveStage(p.value)}>
                <div className="image">
                  <div className="img-wrapper">
                    <img src={p.image} height={"100%"} />
                  </div>
                </div>
                <div className="label">{p.label}</div>
              </div>
            </Col>
          );
        })}
      </Row>
    </ModalComponent>
  );
};

export default HomePageOnboarding;
